import { boot } from '@dazn/bootstrap-lib';

export const createStorageFallback = (): boot.storage.SyncStorage => {
    let items: Record<string, string> = {};
    return {
        setItem: (item, value) => {
            items[item] = value;
        },
        getItem: item => items[item] ?? null,
        clear: () => {
            items = {};
        },
        removeItem: item => {
            delete items[item];
        },
    };
};
